import { CatalogItemScheduleIntervalRequest } from '@common/model/catalog/item/schedule/interval.request';

export class ItemCreateFormModel extends CatalogItemScheduleIntervalRequest {}
